<template>
  <div>
    <div class="card-record" v-for="p in integral" :key="p.id">
      <div>
        <img v-if="p.status == 0" src="../img/auditing.png"></img>
        <img v-else src="../img/audit.png"></img>
      </div>
      <div>
        <div class="top-text">
          <span>{{p.activity_name}}</span>
          <span v-if="p.status == 0" style="float:right;color: #F66B3D;">审核中</span>
          <span v-else-if="p.status == 1" style="float:right;color: #577CCC;">已审核通过，请注意查收</span>
          <span v-else-if="p.status == 2" style="float:right;color: #FF5050;">已驳回，驳回原因请联系工作人员</span>
        </div>
        <div class="bottom-text">
          <span>兑换数量:&nbsp;&nbsp;<span style="color:#577CCC">{{p.exchange_count}}</span></span>
          <span style="float:right;">{{p.application_time}}</span>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { API__code, API_Integral } from '../../api/index.js'
export default {
  data() {
    return {
      activeName: "first",
      integral:[],
      token:'',
      checkCode:''
    };
  },
  created(){
    this.getCookie();
    this.tbCreditsExchangeGetList();
  },
  methods:{
    tbCreditsExchangeGetList(){
      var param = {
        token:this.token,
        checkCode:this.checkCode,
        userId:sessionStorage.getItem('dnnypt_id')
      }
      API_Integral.tbCreditsExchangeGetList(param)
				.then((res)=>{
          if(res.data.code == API__code.SUCCESS){
            this.integral = res.data.data;
          }
        })
    },
		//读取cookie
		getCookie: function() {
		  if (document.cookie.length > 0) {
				var arr = document.cookie.split('; ');
				for (var i = 0; i < arr.length; i++) {
						var arr2 = arr[i].split('=');
						if (arr2[0] == 'dnnypt_token') {
								this.token = arr2[1];
						} else if (arr2[0] == 'dnnypt_checkCode') {
								this.checkCode = arr2[1];
						}
				}
			}
	  }
  }
}
</script>

<style lang="scss" scoped>
.card-record{
  width: 100%;
  height: 72px;
  background: #FFFFFF;
  border-radius: 8px;
  display: flex;
  margin-bottom:12px;

  div:nth-child(1){
    flex: 0 0 10%;
    margin: auto;
    //padding-left: 20px;
    box-sizing: border-box;
    img{
      position: relative;
      left: 35%;
    }
  }

  div:nth-child(2){
    flex: 0 0 90%;
    padding:10px;
    box-sizing: border-box;
  }

  .top-text{
    padding-left: 10px !important;
    padding-right: 10px !important;
    span{
      font-family: Noto Sans SC;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #666666;
    }
  }

  .bottom-text{
    padding-left: 10px !important;
    padding-right: 10px !important;
    span{
      font-family: Noto Sans SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: #999999;
    }
  }
}
</style>




// WEBPACK FOOTER //
// record.vue?51460aec